import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { motion } from "framer-motion";

//Components
import Footer from "../../components/Footer";
import Nav from "../../components/Nav";
import Button from "../../components/Button";

//Local Components
import ImageSection from "./ImageSection";
import ConfigSection from "./ConfigSection";
import ExsistingIntialization from "./ExsisitingIntialization";
import MintInfoSection from "./MintInfoSection";
import MovingSection from "./MovingSection";
import SuccessSection from "./SuccesSection";


//Btns
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import env from "../../constants/env";
import axios from "axios";
import ProcessingModal from "../../components/ProcessingModal";
import Web3 from "web3";
import proxy_token_abi from "../../constants/abi";
import ConfirmModal from "../../components/ConfimModal";

import { MOBILE } from "../../constants/breakpoints";
import colors from "../../constants/colors";
import { proxyTokensPath } from "../../module/routes/path";
import { LoaderContainer } from "./style";

function Config() {
  let wallet = useSelector((state: RootState) => state.walletState);
  let navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  const [nftMetadata, setNftmetadata] = useState<any>({});

  const [assetInfo, setAssetInfo] = useState<
    | {
      assetChain: string;
      assetWalletAddress: string;
      assetContractAddress: string;
      assetId: string;
      proxy_token_exists: boolean;
    }
    | any
  >({});

  useEffect(() => {
    const route = window.location.pathname.split("/");
    if (
      wallet.address == "" ||
      wallet.assetAddress == "" ||
      wallet.assetChain == ""
    ) {
      navigate(`/`);
      return;
    }
    if (route?.length != 6) {
      navigate(`/assets/${wallet.assetChain}/${wallet.assetAddress}`);
      return;
    }

    setAssetInfo({
      assetChain: route[2],
      assetWalletAddress: route[3],
      assetContractAddress: route[4],
      assetId: route[5],
      proxy_token_exists:
        searchParams.get("proxy_token_exists") == "true" ? true : false,
    });
  }, []);

  useEffect(() => {
    if (assetInfo.assetChain) {
      fetchNftInfo();
    }
  }, [assetInfo]);

  const fetchNftInfo = async () => {
    const options = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "X-API-Key": env.MORALIS_API_KEY,
      },
    };
    //   'https://deep-index.moralis.io/api/v2/nft/0x7dE3085b3190B3a787822Ee16F23be010f5F8686/15/metadata?chain=eth' - moralis api structure

    const nftMetadata = await axios.get(
      `${env.MORALIS_URL}/api/v2/nft/${assetInfo.assetContractAddress}/${assetInfo.assetId
      }?chain=${wallet.assetChain == "ETH" ? env.ETH_CHAIN : env.POLYGON_CHAIN
      }`,
      options
    );
    setNftmetadata(nftMetadata.data);
  };

  return (
    <div
      css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          min-height: 100vh;
          background-color: #ffffff;
          background-repeat: no-repeat;
          background-position: top right;
          margin-bottom: 44px;
        `}
    >
      <Nav />
      <section
        css={css`
            display: flex;
            width: 1140px;
            margin: 0 auto;
            margin-top: 110px;
            gap: 70px;

            @media (max-width: ${MOBILE}px) {
              width: 100%;
              padding: 0 12px;
              justify-content: center;
            }
          `}
      >
        {nftMetadata.metadata ? (
          <span
            css={css`
                display: flex;
                column-gap: 50px;

                @media (max-width: ${MOBILE}px) {
                  flex-direction: column;
                }
              `}
          >
            <ImageSection nftMetadata={nftMetadata} />
            <DataSection
              nftMetadata={nftMetadata}
              proxy_token_exists={assetInfo.proxy_token_exists}
            />
          </span>
        ) : (
          ""
        )}
      </section>
    </div>
  );
}

interface IItem {
  name: string
  title: string
}

const DataSection = ({
  nftMetadata,
  proxy_token_exists,
}: {
  nftMetadata: any;
  proxy_token_exists: boolean;
}) => {
  const navigator = useNavigate();
  const [nftData, setNftData] = useState<any>({});
  const [startNew, setStartNew] = useState(false);

  const [approachType, setApproachType] = useState<Partial<IItem>>({ name: 'TYPE_1', title: 'Token Transfer' })

  const [loadingProxyMintInitInfo, setLoadingProxyMintInitInfo] =
    useState(true);

  const [processingRequest, setProcessingRequest] = useState(false);
  const [isInitializingReq, setIsInitializingReq] = useState(false);
  const [isCurrentInitialization, setIsCurrentInitialization] = useState(false);
  const [processingRequestMessage, setProcessingRequestMessage] = useState(".");

  const [storageWalletAddress, setStorageWalletAddress] = useState("");

  const [selectedProxyTokenInitMint, setSelectedProxyTokenInitMint] =
    useState<any>({});

  const [nftMovedToStorage, setNftMovedToStorage] = useState(false);

  const [proxyTokenMintData, setProxyTokenMintData] = useState<any>({});

  const [startNewStorageWalletAddress, setStartNewStorageWalletAddress] =
    useState<any>("");

  const [showConfiguration, setShowConfiguration] = useState(false);

  //  vlaid proxy mint stages
  // 0. INFO
  // 1. PRE_INIT
  // 1.2 EXSISTING_INIT
  // 2. INIT
  // 3. VERIFICATION
  // 4. MINTING

  const [currentProxyMintStage, setCurrentProxyMintStage] = useState("INFO");

  const [currentProxyMintInitInfo, setCurrentProxyMintInitInfo] = useState<any>(
    {}
  );

  let wallet = useSelector((state: RootState) => state.walletState);

  useEffect(() => {
    if (nftMetadata) {
      setNftData(JSON.parse(nftMetadata.metadata));
    }
  }, [nftMetadata]);

  useEffect(() => {
    if (nftMetadata) {
      setCurrentProxyMintStage("INFO");
      setLoadingProxyMintInitInfo(false);
      setProcessingRequest(false);
    }
  }, [nftData]);


  const fetchProxyTokenMintInfo = async () => {
    const fetch_current_proxy_mint_init_info = await axios.get(
      `${env.USER_URL}/proxy-token-mint/existing?nft_asset_chain=${wallet.assetChain}&nft_asset_contract_address=${nftMetadata.token_address}&nft_asset_id=${nftMetadata.token_id}`,
      {
        headers: {
          Authorization: `Bearer ${wallet.jwtToken}`,
        },
      }
    );
    console.log('fetch_current_proxy_mint_init_info', fetch_current_proxy_mint_init_info);

    if (fetch_current_proxy_mint_init_info?.data?.length == 0) {
      setCurrentProxyMintStage("INFO");
    } else {
      setCurrentProxyMintStage("EXSISTING_INIT");
      setIsCurrentInitialization(true)
      setSelectedProxyTokenInitMint(fetch_current_proxy_mint_init_info.data[0])
    }

    setCurrentProxyMintInitInfo(fetch_current_proxy_mint_init_info.data);
    setLoadingProxyMintInitInfo(false);
  };

  const delay = (milliseconds: number) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  const initilizeProxyTokenMint = async (initProxytokenDto: {
    nft_asset_chain: number;
    nft_asset_contract_address: string;
    nft_asset_id: string;
    proxy_token_mint_method: string;
    asset_owner_wallet_address: string;
    asset_storage_wallet_address: string;
  }) => {
    const initilize_proxy_token_mint = await axios.post(
      `${env.USER_URL}/proxy-token-mint/InitiliazeProxyTokenMint`,
      initProxytokenDto,
      {
        headers: {
          Authorization: `Bearer ${wallet.jwtToken}`,
        },
      }
    );
    setIsInitializingReq(true);
    setTimeout(async () => {
      await createProxyTokenInitTx();
    }, 5000);
  };

  const createProxyTokenInitTx = async () => {
    delay(2000)
      .then(async () => {
        // await createProxyTokenInitTx();
        await fetchProxyTokenMintInfo()
        setIsInitializingReq(false);

        // await createInitTx();
      })
      .catch(() => { setIsInitializingReq(false); });
    // setTimeout(async () => {
    // }, 2000);
  };

  const createInitTx = async (preInnit = false) => {
    // check if current chain is poligon amoy testnet
    let tempSelectedProxyTokenInitMint = selectedProxyTokenInitMint;
    if (!preInnit) {
      // create a while loop to check if the tx done in backend or not resolve when done
      const create_proxy_token_init_tx = await axios.get(
        `${env.USER_URL}/proxy-token-mint/existing?nft_asset_chain=${wallet.assetChain}&nft_asset_contract_address=${nftMetadata.token_address}&nft_asset_id=${nftMetadata.token_id}`,
        {
          headers: {
            Authorization: `Bearer ${wallet.jwtToken}`,
          },
        }
      );
      console.log('create_proxy_token_init_tx', create_proxy_token_init_tx);


      if (
        create_proxy_token_init_tx?.data?.length > 1 &&
        storageWalletAddress == "" &&
        wallet.assetAddress !== ""
      ) {
        const user_related_proxy_token_init_tx =
          create_proxy_token_init_tx?.data?.filter((item: any) => {
            return (
              item.asset_owner_wallet_address == wallet.assetAddress &&
              item.asset_storage_wallet_address == storageWalletAddress
            );
          });
        tempSelectedProxyTokenInitMint = user_related_proxy_token_init_tx[0];
        setSelectedProxyTokenInitMint(user_related_proxy_token_init_tx[0]);
        setProcessingRequestMessage("done initilizing, fetching tx data ...");
      }
    }

    // web3js call to create init tx
    const { ethereum }: any = window
    // Check and Switch the network type 
    if (ethereum.networkVersion != env.NETWORK_VERSION) {
      // Only for Brave and Chrome to open Metamask directly insted of opening it through Coinbase
      if (ethereum?.providers) {
        let provider = ethereum.providers.find(({ isMetaMask, isBraveWallet }: any) => isMetaMask && !isBraveWallet)
        if (provider) {
          ethereum.setSelectedProvider(provider)
        }
      }
      // Prompt user to switch to Polygon amoy testnet
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: env.CHAIN_ID }],
      });
    }

    // check if the the proxy token is alreay initilized or not

    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(
      proxy_token_abi,
      env.PROXY_TOKEN_CONTRACT_ADDRESS
    );
    try {
      const proxyTokenAlreadyInitilized = await contract.methods
        .proxyTokenInitializers(tempSelectedProxyTokenInitMint.proxy_token_id)
        .call();

      if (proxyTokenAlreadyInitilized) {
        setProcessingRequestMessage("Proxy token alrady initilized...");
        setCurrentProxyMintStage("VERIFICATION");
        setProcessingRequest(false);
        return;
      }
    } catch (error) {
      console.log(error);
    }

    setProcessingRequestMessage("No Initilization tx found...");
    setProcessingRequestMessage("Creating Init Tx ...");
    if (tempSelectedProxyTokenInitMint?.admin_tx_signature === '') {
      alert('Something went wrong please try again')
      return
    }
    const functionData = contract.methods["initMint"](
      tempSelectedProxyTokenInitMint.proxy_token_id,
      tempSelectedProxyTokenInitMint.admin_tx_signed_at,
      web3.utils.padLeft(
        tempSelectedProxyTokenInitMint.asset_owner_wallet_address,
        64
      ),
      web3.utils.padLeft(
        tempSelectedProxyTokenInitMint.asset_storage_wallet_address,
        64
      ),
      tempSelectedProxyTokenInitMint.admin_tx_signature
    ).encodeABI();


    // Estimate gas
    const gasPrice = await web3.eth.getGasPrice();
    const burnFee = await contract.methods.burnFee().call();
    const platformFee = await contract.methods.platformFee().call();

    const burnFeeBN = web3.utils.toBN(burnFee)
    const platformFeeBN = web3.utils.toBN(platformFee)
    const totalFee = burnFeeBN?.add(platformFeeBN)

    const gasEstimation = await contract.methods
      .initMint(
        tempSelectedProxyTokenInitMint.proxy_token_id,
        tempSelectedProxyTokenInitMint.admin_tx_signed_at,
        web3.utils.padLeft(
          tempSelectedProxyTokenInitMint.asset_owner_wallet_address,
          64
        ),
        web3.utils.padLeft(
          tempSelectedProxyTokenInitMint.asset_storage_wallet_address,
          64
        ),
        tempSelectedProxyTokenInitMint.admin_tx_signature
      )
      .estimateGas({ from: wallet.address ? wallet.address : "", value: totalFee.toString(), gasPrice });

    const gasLimit = Number(web3.utils.toNumber(gasEstimation)) + 100000;
    const gasPriceHex = web3.utils.toHex(gasPrice);
    const gasLimitHex = web3.utils.toHex(gasLimit);

    // Send transaction
    const transaction = {
      from: wallet.address ? wallet.address : "",
      to: env.PROXY_TOKEN_CONTRACT_ADDRESS,
      data: functionData,
      value: totalFee.toString(),
      gasPrice: gasPriceHex,
      gasLimit: gasLimitHex,
    };


    try {
      const result = await web3.eth
        .sendTransaction(transaction)
        .on("transactionHash", (hash: any) => {
          setProcessingRequestMessage(
            "Waiting for Tx to be verified on contract ..."
          );
        })
        .on("receipt", (receipt: any) => {
          if (receipt.status) {
            setProcessingRequestMessage("Tx verified on contract ...");
            setCurrentProxyMintStage("VERIFICATION");
            setProcessingRequest(false);
          } else {
            alert("Tx failed");
            setProcessingRequest(false);
          }
        });
    } catch (error) {
      console.error(error);
      alert("Tx failed");
      setProcessingRequest(false);
    }
  };

  const createMintTx = async () => {
    if (!proxyTokenMintData.admin_tx_signature) {
      alert("some error occured, please try again");
    }

    // web3js call to create init tx

    if (window.ethereum.networkVersion !== env.NETWORK_VERSION) {
      const { ethereum }: any = window

      if (ethereum?.providers) {
        let provider = ethereum.providers.find(({ isMetaMask, isBraveWallet }: any) => isMetaMask && !isBraveWallet)
        if (provider) {
          ethereum.setSelectedProvider(provider)
        }
      }
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: env.CHAIN_ID }],
      });
    }

    // check if the the proxy token is alreay initilized or not

    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(
      proxy_token_abi,
      env.PROXY_TOKEN_CONTRACT_ADDRESS
    );

    let proxyTokenAlreadyInitilized;

    try {
      proxyTokenAlreadyInitilized = await contract.methods
        .ownerOf(proxyTokenMintData.proxy_token_id)
        .call();
    } catch (e) {
      proxyTokenAlreadyInitilized = false;
    }

    if (proxyTokenAlreadyInitilized) {
      setProcessingRequestMessage("Proxy token alrady minted...");
      setCurrentProxyMintStage("FINISH");
      setProcessingRequest(false);
      return;
    }
    setProcessingRequestMessage("Proxy Token Not Minted Yet...");
    setProcessingRequestMessage("Creating Mint Tx ...");

    const functionData = contract.methods["mint"](
      proxyTokenMintData.proxy_token_id,
      proxyTokenMintData.admin_tx_signed_at,
      web3.utils.padLeft(proxyTokenMintData.asset_owner_wallet_address, 64),
      web3.utils.padLeft(proxyTokenMintData.asset_storage_wallet_address, 64),
      proxyTokenMintData.admin_tx_signature
    ).encodeABI();

    const gasPrice = await web3.eth.getGasPrice();
    const gasEstimation = await contract.methods
      .mint(
        proxyTokenMintData.proxy_token_id,
        proxyTokenMintData.admin_tx_signed_at,
        web3.utils.padLeft(proxyTokenMintData.asset_owner_wallet_address, 64),
        web3.utils.padLeft(proxyTokenMintData.asset_storage_wallet_address, 64),
        proxyTokenMintData.admin_tx_signature
      )
      .estimateGas({ from: wallet.address ? wallet.address : "", to: env.PROXY_TOKEN_CONTRACT_ADDRESS, gasPrice });

    const gasLimit = Number(web3.utils.toNumber(gasEstimation)) + 100000;
    const gasPriceHex = web3.utils.toHex(gasPrice);
    const gasLimitHex = web3.utils.toHex(gasLimit);

    // Send transaction
    const transaction = {
      from: wallet.address ? wallet.address : "",
      to: env.PROXY_TOKEN_CONTRACT_ADDRESS,
      data: functionData,
      gasPrice: gasPriceHex,
      gasLimit: gasLimitHex,
    };

    await web3.eth
      .sendTransaction(transaction)
      .on("transactionHash", (hash) => {
        setProcessingRequestMessage(
          "Waiting for Tx to be verified on contract ..."
        );
      })
      .on("receipt", (receipt) => {
        if (receipt.status) {
          setProcessingRequestMessage("Tx verified on contract ...");
          setCurrentProxyMintStage("FINISH");
          setProcessingRequest(false);
        } else {
          alert("Tx failed");
          setProcessingRequest(false);
        }
      }).on('error', (txnError: any) => {
        console.error('error in proxy mint', txnError, txnError?.code, txnError?.message)
      });
  };

  const handleNextBtn = async () => {
    setProcessingRequest(true);
    switch (currentProxyMintStage) {
      case "INFO":
        setProcessingRequestMessage("Fetching nft initiliazation info ...");
        (async () => {
          try {
            const fetch_current_proxy_mint_init_info = await axios.get(
              `${env.USER_URL}/proxy-token-mint/existing?nft_asset_chain=${wallet.assetChain}&nft_asset_contract_address=${nftMetadata.token_address}&nft_asset_id=${nftMetadata.token_id}`,
              {
                headers: {
                  Authorization: `Bearer ${wallet.jwtToken}`,
                },
              }
            );
            if (fetch_current_proxy_mint_init_info?.data?.length == 0) {
              setCurrentProxyMintStage("PRE_INIT");
            } else {
              setCurrentProxyMintStage("EXSISTING_INIT");
            }

            setCurrentProxyMintInitInfo(fetch_current_proxy_mint_init_info.data);
            if (fetch_current_proxy_mint_init_info?.data?.length) setSelectedProxyTokenInitMint(fetch_current_proxy_mint_init_info.data[0])
          } catch (error) {
            console.error(error)
          } finally {
            setProcessingRequest(false);
          }

        })();
        break;
      case "PRE_INIT":
        if (approachType.name === 'TYPE_2') {
          setProcessingRequest(false);
          handleConfirmBtn()
          break;
        }
        if (storageWalletAddress == "") {
          alert("Please enter storage wallet address");
          setProcessingRequest(false);
          break;
        }
        setProcessingRequest(false);
        setShowConfiguration(true);
        break;
      case "EXSISTING_INIT":
        // check for start new flow for Signature verification
        if (approachType.name === 'TYPE_2' && startNew) {
          setProcessingRequest(false);
          handleConfirmBtn(true)
          break;
        }

        setIsCurrentInitialization(false)
        if (selectedProxyTokenInitMint?.proxy_token_mint_method === "MESSAGE_SIGNATURE") {
          setProcessingRequest(false);
          handleConfirmBtn()
          break;
        }
        if (
          (selectedProxyTokenInitMint?.asset_storage_wallet_address === "" ||
            selectedProxyTokenInitMint?.asset_storage_wallet_address ===
            undefined) &&
          storageWalletAddress === "" &&
          !startNewStorageWalletAddress
        ) {
          alert("Please enter storage wallet address");
          setProcessingRequest(false);
          break;
        }

        setProcessingRequest(false);
        setShowConfiguration(true);
        break;

      case "VERIFICATION":
        (async () => {
          try {
            setProcessingRequestMessage("Verifying NFT Transfer...");
            if (!nftMovedToStorage) {
              if (selectedProxyTokenInitMint?.proxy_token_mint_method === "MESSAGE_SIGNATURE") {
                alert("Please scan the code or follow the link to complete the signature verification");
              } else {
                alert("Please move your NFT to storage wallet and try again");
              }
              setProcessingRequest(false);
              return
            }
            await createMintTx();
          } catch (error) {
            console.error(error)
          } finally {
            setProcessingRequest(false);
          }
        })()
        break;
      case "FINISH":
        navigator(proxyTokensPath)
        break;
    }

  };

  const handleBackBtn = () => {
    setShowConfiguration(false);
    switch (currentProxyMintStage) {
      case "INFO":
        navigator(`/assets/${wallet.assetChain}/${wallet.assetAddress}`);
        break;
      case "PRE_INIT":
        setCurrentProxyMintStage("INFO");
        break;
      case "EXSISTING_INIT":
        setIsCurrentInitialization(false)
        setCurrentProxyMintStage("INFO");
        break;
      case "VERIFICATION":
        setCurrentProxyMintStage("EXSISTING_INIT");
        break;
    }
  };

  const handleConfirmBtn = async (isType2?: boolean) => {
    try {
      setShowConfiguration(false);
      setProcessingRequest(true);
      // setShowConfiguration(false);
      if (currentProxyMintStage == "PRE_INIT" || isType2) {
        setProcessingRequestMessage("Intializing Proxy Token Mint");
        if (storageWalletAddress == "" && approachType.name === 'TYPE_1') {
          alert("Please enter storage wallet address");
          return;
        }
        await initilizeProxyTokenMint({
          nft_asset_chain: wallet.assetChain == "ETH" ? 1 : 3,
          nft_asset_contract_address: nftMetadata.token_address,
          nft_asset_id: nftMetadata.token_id,
          proxy_token_mint_method: approachType.name === 'TYPE_1' ? "TOKEN_TRANSFER" : "MESSAGE_SIGNATURE",
          asset_owner_wallet_address: wallet.assetAddress
            ? wallet.assetAddress
            : "",
          asset_storage_wallet_address: approachType.name === 'TYPE_1' ? storageWalletAddress : (wallet.assetAddress ?? ''),
        });
        return;
      } else if (currentProxyMintStage == "EXSISTING_INIT") {
        setProcessingRequestMessage("Fetching existing initialization..");
        if (
          !selectedProxyTokenInitMint?.asset_storage_wallet_address &&
          startNewStorageWalletAddress == "" &&
          selectedProxyTokenInitMint?.proxy_token_mint_method === "TOKEN_TRANSFER"
        ) {
          alert("please enter storage wallet address");
          setProcessingRequest(false);
          return;
        }
        if (startNewStorageWalletAddress !== "") {
          // check if storage wallet already user

          const init_with_wallet_address = currentProxyMintInitInfo.filter(
            (item: any) => {
              return (
                item.asset_storage_wallet_address == startNewStorageWalletAddress
              );
            }
          );

          if (init_with_wallet_address?.length > 0) {
            alert(
              "storage wallet already in use, use the existing initilization"
            );
            setProcessingRequest(false);
            return;
          }

          setStorageWalletAddress(startNewStorageWalletAddress);
          await initilizeProxyTokenMint({
            nft_asset_chain: wallet.assetChain == "ETH" ? 1 : 3,
            nft_asset_contract_address: nftMetadata.token_address,
            nft_asset_id: nftMetadata.token_id,
            proxy_token_mint_method: "TOKEN_TRANSFER",
            asset_owner_wallet_address: wallet.assetAddress
              ? wallet.assetAddress
              : "",
            asset_storage_wallet_address: startNewStorageWalletAddress,
          });
          return;
        }
        try {
          await createInitTx(true);
        } catch (error) {
          console.error(error)
        } finally {
          setProcessingRequest(false);
        }
        return;
      }
    } catch (error) {
      console.error('error', error);
      alert('Something went wrong, Please try again')
    } finally {
      setProcessingRequest(false);
    }
  };

  const getProgress = (): number => {
    if (currentProxyMintStage == "INFO") {
      return 1;
    } else if (currentProxyMintStage == "PRE_INIT") {
      return 1;
    } else if (currentProxyMintStage == "EXSISTING_INIT") {
      return 2;
    } else if (currentProxyMintStage == "VERIFICATION") {
      return 2;
    } else if (currentProxyMintStage == "FINISH") {
      return 3;
    }
    return 0;
  };

  return (
    <div
      css={css`
        margin-top: 125px;

        @media (max-width: ${MOBILE}px) {
          margin-top: 0;
        }
      `}
    >
      {(processingRequest || isInitializingReq) ? (
        <ProcessingModal processingMessage={processingRequestMessage} />
      ) : (
        ""
      )}

      <ProgressComp statusCount={getProgress()} />

      {loadingProxyMintInitInfo ? (
        <ProcessingModal
          processingMessage="Fetching Nft Info..."
          loaderHeading="Loading Data"
        />
      ) : (
        <>
          {(() => {
            switch (currentProxyMintStage) {
              case "INFO":
                return (
                  <MintInfoSection
                    nftData={nftData}
                    proxy_token_exists={proxy_token_exists}
                  />
                );
              case "PRE_INIT":
                return (
                  <>
                    <ConfigSection
                      nftData={nftData}
                      assetWallet={
                        wallet.assetAddress ? wallet.assetAddress : ""
                      }
                      isInitializingReq={isInitializingReq}
                      activeItem={approachType}
                      setActiveItem={setApproachType}
                      storageWalletAddress={storageWalletAddress}
                      setStorageWalletAddress={setStorageWalletAddress}
                    />
                    {showConfiguration && (
                      <ConfirmModal
                        assetWalletAddress={
                          wallet.assetAddress ? wallet.assetAddress : ""
                        }
                        storageWalletAddress={storageWalletAddress}
                        handleContinueBtn={handleConfirmBtn}
                        toggleDropDown={() => {
                          setShowConfiguration(false);
                        }}
                      />
                    )}
                  </>
                );
              case "EXSISTING_INIT":
                return (
                  <>
                    <ExsistingIntialization
                      nftData={nftData}
                      assetWallet={
                        wallet.assetAddress ? wallet.assetAddress : ""
                      }
                      isInitializingReq={isInitializingReq}
                      isCurrentInitialization={isCurrentInitialization}
                      currentProxyMintInitInfo={currentProxyMintInitInfo}
                      selectedProxyTokenInitMint={selectedProxyTokenInitMint}
                      setSelectedProxyTokenInitMint={
                        setSelectedProxyTokenInitMint
                      }
                      setStartNewStorageWalletAddress={
                        setStartNewStorageWalletAddress
                      }
                      startNewStorageWalletAddress={
                        startNewStorageWalletAddress
                      }
                      activeItem={approachType}
                      setActiveItem={setApproachType}
                      nftMetadata={nftMetadata}
                      assetChain={wallet.assetChain}
                      startNew={startNew}
                      setStartNew={setStartNew}
                    />
                    {showConfiguration && (
                      <ConfirmModal
                        assetWalletAddress={
                          wallet.assetAddress ? wallet.assetAddress : ""
                        }
                        storageWalletAddress={
                          storageWalletAddress != ""
                            ? storageWalletAddress
                            : startNewStorageWalletAddress != ""
                              ? startNewStorageWalletAddress
                              : selectedProxyTokenInitMint?.asset_storage_wallet_address
                        }
                        handleContinueBtn={handleConfirmBtn}
                        toggleDropDown={() => {
                          setShowConfiguration(false);
                        }}
                      />
                    )}
                  </>
                );
              // case "INIT":
              //   return <MintInfoSection />;
              case "VERIFICATION":
                return (
                  <MovingSection
                    selectedProxyTokenInitMint={selectedProxyTokenInitMint}
                    nftData={nftData}
                    nftMovedToStorage={nftMovedToStorage}
                    setNftMovedToStorage={setNftMovedToStorage}
                    setProxyTokenMintData={setProxyTokenMintData}
                  />
                );
              case "FINISH":
                return <SuccessSection />;
            }
          })()}

          {/* <ConfigSection nftData={nftData} /> */}
          {/* <MintInfoSection /> */}
          {/* <MovingSection /> */}
          {/* <ExsistingIntialization /> */}
          {/* <SuccessSection /> */}
        </>
      )}

      <div
        id="btnNav"
        css={css`
          display: flex;
          justify-content: space-between;
          margin-top: 25px;
        `}
      >
        <Button type="OUTLINE" onClick={handleBackBtn}>
          Back
        </Button>
        {/* <img
          css={css`
            cursor: pointer;
          `}
          src={next_btn}
          onClick={handleNextBtn}
          alt=""
        /> */}
        <Button isDisabled={isInitializingReq || processingRequest} type="YELLOW" onClick={handleNextBtn}>
          Next
        </Button>
      </div>
    </div>
  );
};

const ProgressComp = ({ statusCount }: { statusCount: number }) => {
  let varients = {
    start: {
      transition: {
        duration: 0,
        ease: "easeInOut",
      },
      d: "M33.3089 15.1758C30.2985 15.1758 27.9098 17.601 26.5898 20.3066C24.3166 24.9659 19.5332 28.1758 14 28.1758C6.26801 28.1758 0 21.9078 0 14.1758C0 6.44379 6.26801 0.175781 14 0.175781C19.3071 0.175781 23.9245 3.1288 26.2987 7.48135C27.6651 9.98633 29.9775 12.1758 32.8309 12.1758H118.502C119.33 12.1758 120.002 12.8474 120.002 13.6758V13.6758C120.002 14.5042 119.33 15.1758 118.502 15.1758H33.3089Z",
    },
    middle: {
      transition: {
        duration: 0.1,
        ease: "easeInOut",
      },
      d: "M14 28.1758C19.5332 28.1758 24.3166 24.9659 26.5898 20.3066C27.9098 17.601 30.2985 15.1758 33.3089 15.1758H239.691C242.702 15.1758 245.09 17.601 246.41 20.3066C248.683 24.9659 253.467 28.1758 259 28.1758C264.533 28.1758 269.317 24.9659 271.59 20.3066C272.91 17.601 275.298 15.1758 278.309 15.1758H288.502C289.33 15.1758 290.002 14.5042 290.002 13.6758V13.6758C290.002 12.8474 289.33 12.1758 288.502 12.1758H277.831C274.977 12.1758 272.665 9.98633 271.299 7.48135C268.925 3.1288 264.307 0.175781 259 0.175781C253.693 0.175781 249.075 3.1288 246.701 7.48135C245.335 9.98633 243.023 12.1758 240.169 12.1758H32.8309C29.9775 12.1758 27.6651 9.98633 26.2987 7.48135C23.9245 3.1288 19.3071 0.175781 14 0.175781C6.26801 0.175781 0 6.44379 0 14.1758C0 21.9078 6.26801 28.1758 14 28.1758Z",
    },
    final: {
      transition: {
        duration: 0.1,
        ease: "easeInOut",
      },
      d: "M33.3968 15.1758C30.4139 15.1758 28.0382 17.5587 26.7092 20.2292C24.417 24.8352 19.6621 28 14.168 28C6.43598 28 0.167969 21.732 0.167969 14C0.167969 6.26801 6.43598 0 14.168 0C19.5155 0 24.1628 2.99821 26.5206 7.40532C27.8796 9.94569 30.2058 12.1758 33.0869 12.1758H240.081C242.962 12.1758 245.288 9.94568 246.647 7.40532C249.005 2.9982 253.652 0 259 0C264.348 0 268.995 2.99821 271.353 7.40533C272.712 9.94569 275.038 12.1758 277.919 12.1758H485.081C487.962 12.1758 490.288 9.94569 491.647 7.40533C494.005 2.99821 498.652 0 504 0C511.732 0 518 6.26801 518 14C518 21.732 511.732 28 504 28C498.506 28 493.751 24.8352 491.459 20.2292C490.13 17.5587 487.754 15.1758 484.771 15.1758H278.229C275.246 15.1758 272.87 17.5587 271.541 20.2292C269.249 24.8352 264.494 28 259 28C253.506 28 248.751 24.8352 246.459 20.2292C245.13 17.5587 242.754 15.1758 239.771 15.1758H33.3968Z",
    },
  };

  return (
    <span
      css={css`
        display: flex;
        position: relative;
        align-items: center;
        width: 518px;

        @media (max-width: ${MOBILE}px) {
          width: 93%;
          margin: 0 auto;
          position: absolute;
          top: 100px;
          max-width: 510px;
        }
      `}
    >
      <span
        css={css`
          display: flex;
          position: absolute;
          justify-content: space-between;
          width: 100%;
          margin-bottom: 60px;
        `}
      >
        {["Intializing", "Minting", "Finish"].map((ele) => {
          return (
            <p
              css={css`
                font-weight: 700;
                font-size: 14px;
                margin: 0;
                margin-right: ${ele === "Minting" ? "20px" : "0"};

                @media (max-width: ${MOBILE}px) {
                  font-size: 12px;
                  color: ${colors.INTERFACE_COLORS_DARK_STONE};
                }
              `}
            >
              {ele}
            </p>
          );
        })}
      </span>
      <span
        css={css`
          position: absolute;
          display: flex;
          width: 100%;
          justify-content: space-between;
          align-items: center;
          top: 0;
          bottom: 0;
          padding: 0 10px;
          font-weight: 700;
          font-size: 14px;

          @media (max-width: ${MOBILE}px) {
            padding: 0 5px;
          }
        `}
      >
        {[1, 2, 3].map((item, index) => (
          <p
            css={css`
              color: ${index <= statusCount - 1 ? "#ffffff" : "#000"};

              @media (max-width: ${MOBILE}px) {
                font-size: 12px;
              }
            `}
          >
            {item}
          </p>
        ))}
      </span>
      <svg
        width="519"
        height="29"
        viewBox="0 0 519 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.3968 15.1758C30.4139 15.1758 28.0382 17.5587 26.7092 20.2292C24.417 24.8352 19.6621 28 14.168 28C6.43598 28 0.167969 21.732 0.167969 14C0.167969 6.26801 6.43598 0 14.168 0C19.5155 0 24.1628 2.99821 26.5206 7.40532C27.8796 9.94569 30.2058 12.1758 33.0869 12.1758H240.081C242.962 12.1758 245.288 9.94568 246.647 7.40532C249.005 2.9982 253.652 0 259 0C264.348 0 268.995 2.99821 271.353 7.40533C272.712 9.94569 275.038 12.1758 277.919 12.1758H485.081C487.962 12.1758 490.288 9.94569 491.647 7.40533C494.005 2.99821 498.652 0 504 0C511.732 0 518 6.26801 518 14C518 21.732 511.732 28 504 28C498.506 28 493.751 24.8352 491.459 20.2292C490.13 17.5587 487.754 15.1758 484.771 15.1758H278.229C275.246 15.1758 272.87 17.5587 271.541 20.2292C269.249 24.8352 264.494 28 259 28C253.506 28 248.751 24.8352 246.459 20.2292C245.13 17.5587 242.754 15.1758 239.771 15.1758H33.3968Z"
          fill="#CCC4B3"
        />
        {/* <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 28.1758C19.5332 28.1758 24.3166 24.9659 26.5898 20.3066C27.9098 17.601 30.2985 15.1758 33.3089 15.1758H239.691C242.702 15.1758 245.09 17.601 246.41 20.3066C248.683 24.9659 253.467 28.1758 259 28.1758C264.533 28.1758 269.317 24.9659 271.59 20.3066C272.91 17.601 275.298 15.1758 278.309 15.1758H288.502C289.33 15.1758 290.002 14.5042 290.002 13.6758V13.6758C290.002 12.8474 289.33 12.1758 288.502 12.1758H277.831C274.977 12.1758 272.665 9.98633 271.299 7.48135C268.925 3.1288 264.307 0.175781 259 0.175781C253.693 0.175781 249.075 3.1288 246.701 7.48135C245.335 9.98633 243.023 12.1758 240.169 12.1758H32.8309C29.9775 12.1758 27.6651 9.98633 26.2987 7.48135C23.9245 3.1288 19.3071 0.175781 14 0.175781C6.26801 0.175781 0 6.44379 0 14.1758C0 21.9078 6.26801 28.1758 14 28.1758Z"
        fill="#191414"
      /> */}
        {/* <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M33.3089 15.1758C30.2985 15.1758 27.9098 17.601 26.5898 20.3066C24.3166 24.9659 19.5332 28.1758 14 28.1758C6.26801 28.1758 0 21.9078 0 14.1758C0 6.44379 6.26801 0.175781 14 0.175781C19.3071 0.175781 23.9245 3.1288 26.2987 7.48135C27.6651 9.98633 29.9775 12.1758 32.8309 12.1758H118.502C119.33 12.1758 120.002 12.8474 120.002 13.6758V13.6758C120.002 14.5042 119.33 15.1758 118.502 15.1758H33.3089Z"
        fill="#191414"
      /> */}
        <motion.path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.3089 15.1758C30.2985 15.1758 27.9098 17.601 26.5898 20.3066C24.3166 24.9659 19.5332 28.1758 14 28.1758C6.26801 28.1758 0 21.9078 0 14.1758C0 6.44379 6.26801 0.175781 14 0.175781C19.3071 0.175781 23.9245 3.1288 26.2987 7.48135C27.6651 9.98633 29.9775 12.1758 32.8309 12.1758H118.502C119.33 12.1758 120.002 12.8474 120.002 13.6758V13.6758C120.002 14.5042 119.33 15.1758 118.502 15.1758H33.3089Z"
          fill="#191414"
          variants={varients}
          animate={Object.keys(varients)[statusCount - 1]}
        />
      </svg>
    </span>
  );
};

export default Config;
